type TPath = {
  path: string;
  name: string;
};

export const paths: TPath[] = [
  {
    path: "/",
    name: "home",
  },
  {
    path: "/recursos",
    name: "recursos",
  },
  {
    path: "/conocenos",
    name: "conocenos",
  },
  {
    path: "/contacto",
    name: "contacto",
  },
  {
    path: "/live",
    name: "en vivo",
  },
];
